export default __webpack_public_path__ + "static/media/data.4933826b.svg";